import { LoaderFunction } from "react-router-dom";
import { axiosApi } from "../../interceptors/axios";
import { Result } from "../../types/Result";
import { Chat } from "../chat/type";
import { Hospital } from "../hospital/type";

export type ChatConversationData = {
  hospital: Hospital | null;
  chats: Chat[];
};

export const chatConversationLoader: LoaderFunction = async ({ params }) => {
  const hospitalId = params.hospitalId;
  const [chatsRes, hospitalRes] = await Promise.all([
    axiosApi.get<Result<Chat[]>>(`/api/chats?hospitalId=${hospitalId}`),
    axiosApi
      .get<Result<Hospital>>(`/api/hospitals/${hospitalId}`)
      .catch(() => null),
  ]);
  const chats = (chatsRes.data.data ?? [])
    .slice()
    .sort(
      (a, b) =>
        new Date(a.creationTime).getTime() - new Date(b.creationTime).getTime()
    );
  const data: ChatConversationData = {
    hospital: hospitalRes?.data.data ?? null,
    chats,
  };
  return data;
};
